import { Container, Sprite, type Texture } from 'pixi.js';
import { TILE_SIZE } from '@/sprites/tiles';
import type { NpcSpriteKey } from '@/sprites/npcs';
import type { NpcPresence } from '@/world/npcs';

/**
 * The people on screen.
 *
 * Pooled like every other renderer. There will never be many at once — a
 * village is a dozen, not a crowd — but the pool costs nothing and means this
 * never becomes the reason a festival is slow.
 */
export class NpcRenderer {
  readonly container = new Container();
  private readonly pool: Sprite[] = [];

  constructor(private readonly textures: Readonly<Record<NpcSpriteKey, Texture>>) {}

  render(present: readonly NpcPresence[]): void {
    let used = 0;

    for (const npc of present) {
      const sprite = this.spriteAt(used++);
      sprite.texture = this.textures[npc.id];
      sprite.position.set(npc.x * TILE_SIZE, npc.y * TILE_SIZE);
      sprite.visible = true;
    }

    for (let i = used; i < this.pool.length; i++) this.pool[i]!.visible = false;
  }

  private spriteAt(index: number): Sprite {
    let sprite = this.pool[index];
    if (!sprite) {
      sprite = new Sprite();
      this.pool.push(sprite);
      this.container.addChild(sprite);
    }
    return sprite;
  }

  destroy(): void {
    this.container.destroy({ children: true });
  }
}
